import { SLIDE_IN_MENUS } from "./../screens/root/constants";
import { hookstate } from "@hookstate/core";
import { ContextReferrer, FunnelConfigTypes } from "../components/funnel/types";
import { ReaderNavigationContext } from "../screens/reader/types";
import { NAVBAR_HEIGHT } from "../screens/root/constants";

interface SlideInMenuConfig {
  menuInstanceId?: string;
  releaseUuid?: string;
  comicSlug?: string;
  artistId?: number;
  username?: string;
  bundleId?: string;
  navigationContext?: ReaderNavigationContext;
}
export type rootComponentsStoreTypes = {
  funnelModal: FunnelConfigTypes;

  isSidebarOpen: boolean;

  isTopBarHidden?: boolean;
  topBarHeight: number;

  eventTrackingQueryParams?: string;
  eventContextReferrer?: ContextReferrer;

  openSlideInMenu?: SLIDE_IN_MENUS;
  slideInMenuConfig: SlideInMenuConfig;
  slideInMenuHistory: Array<{
    config?: SlideInMenuConfig;
    type: SLIDE_IN_MENUS;
  }>;

  mixpanelInitialized: boolean;
  isInitialLoad: boolean;

  timer: number;

  locationHistory: string[];
};
export const rootComponentsStore = hookstate<rootComponentsStoreTypes>({
  isInitialLoad: true,
  mixpanelInitialized: false,
  timer: Date.now(),

  isSidebarOpen: true,
  funnelModal: {},

  eventTrackingQueryParams: undefined,
  eventContextReferrer: undefined,

  isTopBarHidden: false,
  topBarHeight: NAVBAR_HEIGHT,

  openSlideInMenu: undefined,
  slideInMenuConfig: {},
  slideInMenuHistory: [],
  locationHistory: [],
});
